<p class="_custom_progress">
   <ngb-progressbar *ngIf="progrssBarValue > 0" class="_custom_progress" type="info" id="nexg_ngb-progressbar"
      [value]="progrssBarValue">
   </ngb-progressbar>
</p>
<div class="maincontentarea _beforeLoad" id="maincontentarea" style="margin: 0;">

   <div class="maincontentarea" style="margin:0;">



      <div *ngIf="!showError">
         <section class="_detail_banner _read_more" [ngClass]="{'active': readmoreCond }">

            <div class="_det_img" id="detail_banner">
               <div *ngIf="is_preview" class="trailer_video" id="trailer_video">
                  <video id="preview_video" class="video-js vjs-fluid  vjs-16-9" controls autoplay preload="auto"
                     playsinline>
                     <!-- <source src="https://www.w3schools.com/html/mov_bbb.mp4" type="video/mp4" />
   <source src="https://www.w3schools.com/html/mov_bbb.mp4" type="video/webm" /> -->
                     <p class="vjs-no-js">
                        To view this video please enable JavaScript, and consider upgrading to a
                        web browser that
                        <a href="https://videojs.com/html5-video-support/" target="_blank">supports HTML5 video</a>
                     </p>
                  </video>
               </div>
            </div>
            <div class="detailContent">
               <div class="container">
                  <div class="row">
                     <div class="col-sm-12">
                        <!-- <button>fdsfdsl</button> -->
                        <div class="_detail_p_t_i">
                           <div class="_detail_r_text" [ngClass]="{'hoverDetailFullWidth': readmoreCond}">

                              <h2 *ngIf="episodeDeatil?.name">{{episodeDeatil?.name}}
                                 <!-- <span *ngIf="episodeDeatil.name && episodeDeatil.name.length > 20">...</span> -->
                              </h2>


                              <ul *ngIf="tempQueryStr.type=='episode' || tempQueryStr.type=='tvshow' ">
                                 <!-- <li *ngIf="episodeDeatil?.languages">{{episodeDeatil?.languages}}</li> -->
                                 <!-- {{episodeDeatil|json}} -->
                                 <!-- <li *ngIf="episodeDeatil?.genre_text">{{episodeDeatil?.genre_text}}</li> -->

                                 <!-- <li *ngIf="episodeDeatil.hours || episodeDeatil.min || episodeDeatil.sec">
                                    <span *ngIf="episodeDeatil.hours && episodeDeatil.hours !='00' ">
                                       {{commonService.pad(episodeDeatil.hours)}}{{episodeDeatil.hours>0?'h':'
                                       '}}</span>
                                    <span
                                       *ngIf="episodeDeatil.min && episodeDeatil.min>0 && (episodeDeatil.hours != '00')">
                                       {{commonService.pad(episodeDeatil.min)}}{{episodeDeatil.min>0?'m':''}}
                                    </span>
                                    <span *ngIf="episodeDeatil.min && (episodeDeatil.hours == '00')">
                                       {{commonService.pad(episodeDeatil.min)}}{{episodeDeatil.min>0?'m':''}}
                                    </span>
                                    <span
                                       *ngIf="episodeDeatil.sec && (episodeDeatil.hours =='00' && episodeDeatil.min >0 )">
                                       {{commonService.pad(episodeDeatil.sec)}}{{episodeDeatil.sec>0?'s':''}}
                                    </span>

                                    <span
                                       *ngIf="episodeDeatil.sec && (episodeDeatil.hours =='00' && episodeDeatil.min =='00' )">
                                       {{commonService.pad(episodeDeatil.sec)}}{{episodeDeatil.sec>0?'s':''}}
                                    </span>
                                 </li> -->

                                 <!-- <li *ngIf="(episodeDeatil?.viewer_rating) && episodeDeatil?.viewer_rating?.rating_name">
                                 {{episodeDeatil?.viewer_rating?.rating_name}}
                              </li> -->

                              </ul>

                              <ul *ngIf="tempQueryStr.type=='movie'">
                                 <!-- <li *ngIf="episodeDeatil?.languages">{{episodeDeatil?.languages}}</li>
                                 <li *ngIf="episodeDeatil?.genre_text">{{episodeDeatil?.genre_text}}</li> -->
                                 <!-- <li *ngIf="episodeDeatil.hours || episodeDeatil.min || episodeDeatil.sec">
                                    <span *ngIf="episodeDeatil.hours && episodeDeatil.hours !='00' ">
                                       {{commonService.pad(episodeDeatil.hours)}}{{episodeDeatil.hours>0?'h':'
                                       '}}</span>
                                    <span
                                       *ngIf="episodeDeatil.min && episodeDeatil.min>0 && (episodeDeatil.hours != '00')">
                                       {{commonService.pad(episodeDeatil.min)}}{{episodeDeatil.min>0?'m':''}}
                                    </span>
                                    <span *ngIf="episodeDeatil.min && (episodeDeatil.hours == '00')">
                                       {{commonService.pad(episodeDeatil.min)}}{{episodeDeatil.min>0?'m':''}}
                                    </span>
                                    <span
                                       *ngIf="episodeDeatil.sec && (episodeDeatil.hours =='00' && episodeDeatil.min >0 )">
                                       {{commonService.pad(episodeDeatil.sec)}}{{episodeDeatil.sec>0?'s':''}}
                                    </span>

                                    <span
                                       *ngIf="episodeDeatil.sec && (episodeDeatil.hours =='00' && episodeDeatil.min =='00' )">
                                       {{commonService.pad(episodeDeatil.sec)}}{{episodeDeatil.sec>0?'s':''}}
                                    </span>
                                 </li> -->
                                 <!-- <li *ngIf="episodeDeatil?.viewer_rating?.rating_name">
                                 {{episodeDeatil?.viewer_rating?.rating_name}}
                              </li> -->
                              </ul>
                              <ul *ngIf="tempQueryStr.type=='livetv'">
                                 <!-- <li *ngIf="episodeDeatil?.languages">{{episodeDeatil?.languages}}</li>
                                 <li *ngIf="episodeDeatil?.genre_text">{{episodeDeatil?.genre_text}}</li> -->
                                 <!-- <li *ngIf="episodeDeatil.hours || episodeDeatil.min || episodeDeatil.sec">
                                    <span
                                       *ngIf="episodeDeatil.hours && episodeDeatil.hours !='00' ">{{commonService.pad(episodeDeatil.hours)}}{{episodeDeatil.hours>1
                                       ? 'h':'h'}}</span>
                                    <span
                                       *ngIf="episodeDeatil.min && episodeDeatil.min>1 && (episodeDeatil.hours != '00')">{{commonService.pad(episodeDeatil.min)}}{{episodeDeatil.min>1?'m':'m'}}</span>
                                    <span
                                       *ngIf="episodeDeatil.min && (episodeDeatil.hours == '00')">{{commonService.pad(episodeDeatil.min)}}{{episodeDeatil.min>1?'m':'m'}}</span>

                                    <span
                                       *ngIf="episodeDeatil.sec && (episodeDeatil.hours =='00' && episodeDeatil.min =='00' )">
                                       {{commonService.pad(episodeDeatil.sec)}}'s'}}
                                    </span>
                                 </li> -->
                              </ul>
                              <div class="_collapse_content">
                                 <p class="_coll_data">
                                    <!-- {{episodeDeatil.synopsis | slice:0:255}} -->
                                    <!-- {{readmoreCond}} -->
                                    {{readmoreCond?episodeDeatil.synopsis: episodeDeatil.synopsis | slice:0:235}}
                                    <!-- {{episodeDeatil.is_pack_active}} {{episodeDeatil.content_availability}} -->
                                    <!-- <span
                                    *ngIf="episodeDeatil.synopsis && episodeDeatil.synopsis.length > 235 && readmoreCond == false ">...</span> -->

                                 </p>

                                 <a *ngIf="episodeDeatil.synopsis && episodeDeatil.synopsis.length > 235"
                                    href="javascript:void(0)" (click)="readMore()"
                                    class="_read_less"><span>{{readMoreText}}</span> <img
                                       src="assets/img/read_less_arrow.png"></a>

                                 <div class="rating_bottom_show"
                                    *ngIf="(episodeDeatil?.viewer_rating) && episodeDeatil?.viewer_rating?.rating_name">
                                    {{episodeDeatil?.viewer_rating?.rating_name}}
                                 </div>
                              </div>
                           </div>

                        </div>
                        <div class="event_sch_time" *ngIf="episodeDeatil.type == 'event'">
                           {{this.episodeDeatil.scheduled_time}}</div>
                        <div class="_r_w_e"
                           *ngIf="episodeDeatil.type != 'livetv' && strToLower(episodeDeatil.recently_watched?.content_availability) != 'paid' || episodeDeatil.is_pack_active == 1 ">



                           <a class="_play_player"
                              (click)="episodeDeatil.watch == 'trailer' && episodeDeatil.watch != 'content' && episodeDeatil.type!= 'event' ? playMovieTrailer(episodeDeatil, play_trailer) : playvideo(episodeDeatil, content)">
                              <img src="assets/img/hover_Play.png" *ngIf="episodeDeatil.type != 'event'">

                              <img src="assets/img/hover_Play.png"
                                 *ngIf="episodeDeatil.type == 'event' && is_event_started && episodeDeatil.watch== 'content'">
                              <div class="watchNow test">
                                 <!-- <h3 >Continue Watching</h3> -->
                                 <!-- <h3 class="continue-watch" *ngIf="episodeDeatil.type=='vod'">Watch Now</h3> -->
                                 <div>

                                 </div>
                                 <h3 class="continue-watch"
                                    *ngIf="episodeDeatil.watch == 'content' && episodeDeatil.type != 'event'">
                                    {{episodeDeatil.recently_watched.stop == '0' ?'Watch Now':'Continue Watching'}}
                                 </h3>
                                 <h3 class="continue-watch"
                                    *ngIf="episodeDeatil.type == 'event' && is_event_started && episodeDeatil.watch=='content'">
                                    Watch Live
                                 </h3>
                                 <h3 class="continue-watch"
                                    *ngIf="episodeDeatil.watch == 'trailer' && episodeDeatil.type != 'event'">
                                    Watch Trailer
                                 </h3>

                                 <div *ngIf="episodeDeatil.type=='episode' || episodeDeatil.type =='tvshow'">
                                    <p
                                       *ngIf="episodeDeatil.recently_watched && episodeDeatil.recently_watched.stop > '0' ">
                                       <span
                                          *ngIf="this.seasonData.result.season.length > 1">S{{episodeDeatil.recently_watched.season.season_number}}
                                       </span>
                                       <span> Episode {{episodeDeatil.recently_watched.no}} |
                                          {{ secondsToHms(episodeDeatil.recently_watched.remaining_time) }} LEFT </span>
                                    </p>

                                    <p
                                       *ngIf="episodeDeatil.recently_watched && episodeDeatil.recently_watched.stop ==  '0' ">
                                       <span *ngIf="this.seasonData.result.season.length > 1">
                                          S{{episodeDeatil.recently_watched.season.season_number}} </span>
                                       <span>Episode {{episodeDeatil.recently_watched.no}} </span>
                                    </p>
                                 </div>

                                 <div
                                    *ngIf="episodeDeatil.type=='movie' && episodeDeatil.watch== 'content' || episodeDeatil.type=='vod' && episodeDeatil.watch== 'content'">
                                    <p
                                       *ngIf="episodeDeatil.recently_watched && episodeDeatil.recently_watched.stop > '0' ">
                                       {{ secondsToHms(episodeDeatil.recently_watched.remaining_time) }} LEFT
                                    </p>
                                 </div>

                                 <div class="progress"
                                    *ngIf="episodeDeatil.recently_watched && episodeDeatil.recently_watched.stop > 0 && episodeDeatil.type!='event' && episodeDeatil.type!='livetv' && episodeDeatil.watch== 'content'">
                                    <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0"
                                       aria-valuemax="100"
                                       [ngStyle]="{'width': episodeDeatil.recently_watched.stop*100/episodeDeatil.recently_watched.duration+'%'}">
                                    </div>
                                 </div>
                              </div>

                              <div class="watchNow test" *ngIf="!episodeDeatil.recently_watched">
                                 <!-- <h3>Watch Now</h3> -->
                                 <!-- <p>{{  (episodeDeatil.recently_watched.stop)/3600 }} mins left </p> -->
                                 <div class="progress">
                                    <!-- <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0"
                                    aria-valuemax="100" [ngStyle]="{'width': episodeDeatil.recently_watched.stop*100/episodeDeatil.recently_watched.duration+'%'}">
                                 </div> -->
                                 </div>
                              </div>
                           </a>
                        </div>
                        <div class="_r_w_e"
                           *ngIf="episodeDeatil.type != 'livetv'  && (strToLower( episodeDeatil.recently_watched.content_availability ) == 'paid' && episodeDeatil.is_pack_active == 0)  && !is_event_streamed"
                           (click)="gotoChoosePlan()">
                           <div class="_watch_add_buy">
                              <!-- <p class="_paid_c pointer_cursor" *ngIf="episodeDeatil.type=='episode'">{{episodeDeatil.recently_watched.stop == '0'?'Watch ':'Continue Watching'}}  S{{episodeDeatil.recently_watched.season.season_number}}  E{{episodeDeatil.recently_watched.no}}</p> -->
                              <!-- <p class="_paid_c"  *ngIf="episodeDeatil.type=='vod' || episodeDeatil.type=='movie' ">{{episodeDeatil.recently_watched.stop == '0'?'Watch':'Continue Watching'}}  </p> -->


                              <a class="_d_buy_c">
                                 <img class="_d_crown" src="assets/img/crown.png">
                                 <span>Buy Now</span>
                                 <img class="_d_play" src="assets/img/Buy_Now_Play_Icon.png">
                              </a>
                           </div>
                        </div>
                        <!-- 
                        <div class="_r_w_e"
                           *ngIf="episodeDeatil.type == 'event'  && (strToLower( episodeDeatil.recently_watched.content_availability ) == 'paid' && episodeDeatil.is_pack_active == 0) && !is_event_streamed"
                           (click)="gotoChoosePlan()">
                           <div class="_watch_add_buy">
                              <a class="_d_buy_c">
                                 <img class="_d_crown" src="assets/img/crown.png">
                                 <span>Buy Now</span>
                                 <img class="_d_play" src="assets/img/Buy_Now_Play_Icon.png">
                              </a>
                           </div>
                        </div> -->

                        <div class="_r_w_e"
                           *ngIf="episodeDeatil.type == 'livetv' && (strToLower( episodeDeatil.content_availability ) == 'paid' && episodeDeatil.is_pack_active == 0)"
                           (click)="gotoChoosePlan()">
                           <div class="_watch_add_buy">

                              <a class="_d_buy_c">
                                 <img class="_d_crown" src="assets/img/crown.png">
                                 <span>Buy Now</span>
                                 <img class="_d_play" src="assets/img/Buy_Now_Play_Icon.png">
                              </a>
                           </div>
                        </div>

                        <div class="_r_w_e"
                           *ngIf="episodeDeatil.type == 'livetv' && (strToLower( episodeDeatil.content_availability ) == 'paid' && episodeDeatil.is_pack_active == 1)"
                           (click)="playvideo(episodeDeatil, contentLive)">

                           <a class="_play_player">
                              <img src="assets/img/hover_Play.png">

                              <div class="watchNow">
                                 <h3>Watch Now</h3>
                              </div>
                           </a>
                        </div>

                        <div class="_r_w_e"
                           *ngIf="episodeDeatil.type == 'livetv' && (strToLower( episodeDeatil.content_availability ) == 'free' || episodeDeatil.is_pack_active == 1)"
                           (click)="playvideo(episodeDeatil, contentLive)">

                           <a class="_play_player">
                              <img src="assets/img/hover_Play.png">

                              <div class="watchNow">
                                 <h3>Watch Now</h3>
                                 <!-- <p>{{  (episodeDeatil.recently_watched.stop)/3600 }} mins left </p> -->
                                 <!--<div class="progress">
                              <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0"
                                 aria-valuemax="100" [ngStyle]="{'width': episodeDeatil.recently_watched.stop*100/episodeDeatil.recently_watched.duration+'%'}">
                              </div> 
                           </div>-->
                              </div>
                           </a>
                        </div>


                        <ul class="_list_t">
                           <li
                              *ngIf="episodeDeatil.type != 'livetv' && episodeDeatil.type != 'event' && episodeDeatil.watch == 'content' && episodeDeatil.recently_watched.stop != '0' && (strToLower( episodeDeatil.recently_watched.content_availability ) == 'free' 
                           || strToLower( episodeDeatil.recently_watched.content_availability ) == 'no tag'  || episodeDeatil.is_pack_active == 1)">
                              <a
                                 (click)="playvideoFromStarts(episodeDeatil, playFromStart, ( strToLower(episodeDeatil.recently_watched.content_availability ) == 'free' 
                              || strToLower( episodeDeatil.recently_watched.content_availability ) == 'no tag' || episodeDeatil.is_pack_active == 1))">
                                 <div class="icon-img">
                                    <img src="assets/img/Icon/play-begin.png" alt="watch trailer">
                                 </div>
                                 <span>Play From <br> Beginning</span>
                              </a>
                           </li>
                           <li *ngIf="episodeDeatil.new_trailer && episodeDeatil.new_trailer.length != 0">
                              <a (click)="playMovieTrailer(episodeDeatil, play_trailer)">
                                 <div class="icon-img">
                                    <img src="assets/img/Watch_Now.png" alt="watch trailer">
                                 </div>
                                 <span>Trailer</span>
                              </a>
                           </li>

                           <li
                              *ngIf="episodeDeatil.type != 'event' &&  (episodeDeatil.type=='episode' || episodeDeatil.type =='tvshow' && episodeDeatil.watch !='trailer') || (episodeDeatil.type=='livetv' || episodeDeatil.type =='movie' || episodeDeatil.type =='vod')">
                              <a (click)="AddToWatchList($event, episodeDeatil)">
                                 <div class="icon-img">
                                    <!-- <img src="assets/img/watch_list.png" alt="Watchlist"> -->
                                    <img
                                       [src]="episodeDeatil.is_watchlist_added?'assets/img/Added_to_Watchlist.png':'assets/img/Add-to_Watchlist.png'">
                                    <!-- <img src="assets/img/Add-to_Watchlist.png" alt="Watchlist"> -->
                                 </div>
                                 <span>Watchlist</span>
                              </a>
                              <span class="tooltip_hover">
                                 {{episodeDeatil.is_watchlist_added?'Remove from Watchlist':'Add to Watchlist'}}
                              </span>
                           </li>
                           <li>
                              <a href="javascript:;" data-toggle="modal" data-target="#sharebuttons">
                                 <div class="icon-img">
                                    <img src="assets/img/share.png" alt="share">
                                 </div>
                                 <span>share</span>
                              </a>
                           </li>


                        </ul>
                     </div>

                     <div class="preview-mute"
                        *ngIf="is_preview && episodeDeatil.preview && episodeDeatil.preview.length">
                        <img [src]="!is_muted ? 'assets/img/unmute2.png' : 'assets/img/mute2.png'"
                           (click)="!is_muted ? muteUnmutePreview(0) : muteUnmutePreview(1)">
                     </div>



                  </div>
               </div>
            </div>
         </section>



         <!-- Episode list -->
         <section class="assests-detail">
            <div class="container">
               <div class="row">
                  <div class="col-sm-12" *ngIf="episodeDeatil.type != 'livetv'">

                     <ul class="nav nav-tabs" id="myTab" role="tablist">
                        <li class="nav-item"
                           *ngIf="tempQueryStr.type !='tvshow' && episodeDeatil.new_trailer && episodeDeatil.new_trailer.length > 1">
                           <a class="nav-link " [ngClass]="{'active show':episodeDeatil.new_trailer.length > 1}"
                              id="trailer-tab" data-toggle="tab" href="#trailer" role="tab" aria-controls="trailer"
                              aria-selected="true">Trailer & Preview</a>
                        </li>

                        <!-- old episode -->
                        <!-- <li class="nav-item" *ngIf="tempQueryStr.type =='tvshow' && seasonData && seasonData.result && seasonData.result.length > 0">
                           <a class="nav-link "
                              [ngClass]="{'active show': tempQueryStr.type =='tvshow'}"
                              id="episode-tab" data-toggle="tab" href="#episode" role="tab" aria-controls="episode"
                              aria-selected="true">Episodes</a>
                        </li> -->

                        <li class="nav-item"
                           *ngIf="tempQueryStr.type =='tvshow' && seasonData && seasonData.result && seasonData.result.season.length > 0">
                           <a class="nav-link " [ngClass]="{'active show': tempQueryStr.type =='tvshow'}"
                              id="episode-tab" data-toggle="tab" href="#episode" role="tab" aria-controls="episode"
                              aria-selected="true">Episodes</a>
                        </li>
                        <li class="nav-item"
                           *ngIf="tempQueryStr.type =='tvshow' && episodeDeatil.new_trailer && episodeDeatil.new_trailer.length > 1">
                           <a class="nav-link "
                              [ngClass]="{'active show': (tempQueryStr.type =='tvshow' && seasonData && seasonData.result && seasonData.result.season.length<1 && episodeDeatil.new_trailer.length > 1)}"
                              id="trailer-tab" data-toggle="tab" href="#trailer" role="tab" aria-controls="trailer"
                              aria-selected="true">Trailer & Preview</a>
                        </li>
                        <li class="nav-item" *ngIf="recommendedData.result && recommendedData.result.length > 0">
                           <a class="nav-link"
                              [ngClass]="{'active show': (tempQueryStr.type !='tvshow' && episodeDeatil.new_trailer && episodeDeatil.new_trailer.length <= 1  && recommendedData.result && recommendedData.result.length > 0
                                                      || tempQueryStr.type =='tvshow' && episodeDeatil.new_trailer && episodeDeatil.new_trailer.length <= 1 && seasonData && seasonData.result && seasonData.result.season && seasonData.result.season.length<1 && recommendedData.result && recommendedData.result.length > 0)}"
                              id="recommend-tab" data-toggle="tab" href="#recommendforyou" role="tab"
                              aria-controls="recommend" aria-selected="false">Similar</a>
                        </li>
                        <li class="nav-item">
                           <a class="nav-link" [ngClass]="{'active show': (recommendedData.result.length<=0 || recommendedData.result==false) && episodeDeatil.new_trailer.length<=1 && !seasonData && seasonData==undefined
                           || (recommendedData.result.length<=0 || recommendedData.result==false) && episodeDeatil.new_trailer.length<=1 && tempQueryStr.type =='tvshow' && seasonData && seasonData.result}" id="moreinfo-tab" data-toggle="tab"
                              href="#moreinfo" role="tab" aria-controls="moreinfo" aria-selected="false">More Info</a>
                        </li>
                     </ul>
                     <div class="tab-content assests-content" id="myTabContent">

                        <div class="tab-pane fade show"
                           [ngClass]="{'active show': (episodeDeatil.new_trailer.length > 1 && tempQueryStr.type !='tvshow' || tempQueryStr.type =='tvshow' && episodeDeatil.new_trailer.length > 1 && seasonData && seasonData.result && seasonData.result.season.length<1)}"
                           id="trailer" role="tabpanel" aria-labelledby="trailer-tab"
                           *ngIf="episodeDeatil.new_trailer && episodeDeatil.new_trailer.length > 0">

                           <div class="season-detail wow animate__animated  animate__fadeInUp"
                              *ngFor="let item of episodeDeatil.new_trailer; let i=index">
                              <div class="episode-img" (click)="playTrailerFromList(i, play_episode)">
                                 <!-- <img src="{{item.image}}" alt="episode_img" class="_ep_img"> -->
                                 <image-manipulation [img]="isCloudFrontType == false ? item.image : item.cloudfront_url" [params]="{'width':291,'height':160}" [notFound]="notFoundImg">
                                 </image-manipulation>
                                 <!-- <a class="_premium" *ngIf="strToLower(item.content_availability) != 'free'">
                                 <img class="crown" src="assets/img/crown.png">
                              </a> -->

                                 <a class="_premium" *ngIf="strToLower(item.content_availability) == 'paid'">
                                    <img class="crown" src="assets/img/crown.png">
                                 </a>

                                 <a class="_free_tag" *ngIf="strToLower(item.content_availability) == 'free'">
                                    <img class="crown" src="assets/img/free_tag_76x35.png">
                                 </a>

                                 <a class="_free_tag" *ngIf="strToLower(item.content_availability) == 'no tag'">
                                    <!-- <img class="crown" src="assets/img/free_tag_76x35.png"> -->
                                 </a>

                                 <!-- <div class="progress progress_bottom_img" *ngIf="item.seek_bar_data">
                                 <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0"
                                    aria-valuemax="100"
                                    [ngStyle]="{'width': (item.seek_bar_data.stop*100/item.seek_bar_data.duration) >= 97 ? (item.seek_bar_data.stop*100/item.seek_bar_data.duration+2): (item.seek_bar_data.stop*100/item.seek_bar_data.duration)  +'%'}">
                                 </div>
                              </div> -->

                                 <!-- <div class="shade" *ngIf="( 
                                          (item.seek_bar_data.stop*100/item.seek_bar_data.duration) >= 97 ? 
                                          (item.seek_bar_data.stop*100/item.seek_bar_data.duration)+2: 
                                          item.seek_bar_data.stop*100/item.seek_bar_data.duration
                                    ) > 98"></div> -->
                                 <a href="javascript:;" class="_ep_p">
                                    <img src="assets/img/asset_play_icon.png" class="_ep_icon_play">
                                 </a>
                                 <!-- 
                                 <div class="progress">
                                          <div class="progress-bar" style="width:0%"></div>
                                 </div> 
                              -->
                              </div>
                              <div class="episode-detail">
                                 <div class="ep-no">
                                    <h4><b>{{i+1}}. </b>{{item.trailer_title}}
                                       <!-- {{item.code}} -->
                                    </h4>



                                    <!-- (item.seek_bar_data.stop*100/item.seek_bar_data.duration) >= 96 ? (item.seek_bar_data.stop*100/item.seek_bar_data.duration+2): (item.seek_bar_data.stop*100/item.seek_bar_data.duration) -->
                                    <!-- {{item.seek_bar_data.stop}}
                                 {{item.seek_bar_data.duration}}
                                 {{(item.seek_bar_data.stop*100/item.seek_bar_data.duration)}} -->
                                    <!-- <div  class="progress episode-fix" *ngIf="item.seek_bar_data">
                                    <div  class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0"
                                       aria-valuemax="100"
                                       [ngStyle]="{'width': (item.seek_bar_data.stop*100/item.seek_bar_data.duration) >= 97 ? (item.seek_bar_data.stop*100/item.seek_bar_data.duration+2): (item.seek_bar_data.stop*100/item.seek_bar_data.duration)  +'%'}">
                                    </div>
                                 </div> -->
                                 </div>
                                 <div class="ep-detail">

                                    <p class="synopsisHight" (click)="expendEpisodeSynopsis(i)"
                                       [ngClass]="{'episodeSynopsisHight': episodeIndex == i}">
                                       {{item.trailer_synopsis}}</p>
                                    <!-- <p>{{item.trailer_synopsis}}</p> -->
                                    <!-- {{readmoreCond?episodeDeatil.synopsis: episodeDeatil.synopsis | slice:0:255}} -->

                                    <!-- <p>{{episodeMoreCond? tempSynapsi : tempSynapsi|slice:0:100  }}</p> -->
                                    <div class="time"
                                       *ngIf="item.trailer_hrs >0 && item.trailer_min >0&& item.trailer_sec>0">
                                       <p *ngIf="item.trailer_hrs > 0">
                                          <span>{{commonService.pad(item.trailer_hrs)}}h</span>
                                       </p>
                                       <p *ngIf="item.trailer_min > 0">
                                          <span>{{commonService.pad(item.trailer_min)}}m</span>
                                       </p>
                                    </div>

                                    <div class="time"
                                       *ngIf="!(item.trailer_hrs >0 && item.trailer_min >0&& item.trailer_sec>0)">

                                       <p *ngIf="item.trailer_hrs > 0">
                                          <span>{{commonService.pad(item.trailer_hrs)}}h</span>
                                       <p *ngIf="item.trailer_min > 0">
                                          <span>{{commonService.pad(item.trailer_min)}}m</span>
                                       <p>
                                       <p *ngIf="item.trailer_sec > 0">
                                          <span>{{commonService.pad(item.trailer_sec)}}{{item.sec >
                                             1?'s':'s'}}</span>
                                       </p>
                                    </div>
                                 </div>
                              </div>
                           </div>


                        </div>

                        <!-- old episode code -->

                        <!-- <div class="tab-pane fade show" id="episode" role="tabpanel" aria-labelledby="episode-tab"
                        [ngClass]="{'active show': (tempQueryStr.type =='tvshow')}"
                           *ngIf="tempQueryStr.type == 'tvshow' && seasonData && seasonData.result.length && seasonData.result[seasonIndex]">

                           <div class="dropdown season-drpdwn">

                              <button class="btn btn-secondary dropdown-toggle season-button" type="button"
                                 id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                 aria-expanded="false">
                                 {{currentSeaon?currentSeaon:'Season 1'}} <i class="fa fa-angle-down"
                                    aria-hidden="true"></i>
                              </button>

                              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                 <a class="dropdown-item" *ngFor="let season of seasonData.result; let i=index"
                                    (click)="changeSeason(i+1, season.season_number)">Season {{i+1}} </a>
                              </div>
                           </div>
                           <div class="season-detail wow animate__animated  animate__fadeInUp" 
                              *ngFor="let item of seasonData.result[seasonIndex].assets; let i=index">
                              <div class="episode-img" (click)="playvideoRecomnd(item, play_episode)">
                        
                                 <image-manipulation [img]="item.image" [params]="{'width':291,'height':160}">
                                 </image-manipulation>
                              

                                 <div *ngIf="item.hide_tag!=1">
                                 <a class="_premium" *ngIf="strToLower(item.content_availability) == 'paid'">
                                    <img class="crown" src="assets/img/crown.png">
                                 </a>

                                 <a class="_free_tag" *ngIf="strToLower(item.content_availability) == 'free'">
                                    <img class="crown" src="assets/img/free_tag_76x35.png">
                                 </a>

                                 <a class="_free_tag" *ngIf="strToLower(item.content_availability) == 'no tag'">
                                 </a>
                              </div>

                                 <div class="progress progress_bottom_img" *ngIf="item.seek_bar_data">
                                    <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0"
                                       aria-valuemax="100"
                                       [ngStyle]="{'width': (item.seek_bar_data.stop*100/item.seek_bar_data.duration) >= 97 ? (item.seek_bar_data.stop*100/item.seek_bar_data.duration+2): (item.seek_bar_data.stop*100/item.seek_bar_data.duration)  +'%'}">
                                    </div>
                                 </div>

                                 <div class="shade" *ngIf="( 
                                             (item.seek_bar_data.stop*100/item.seek_bar_data.duration) >= 97 ? 
                                             (item.seek_bar_data.stop*100/item.seek_bar_data.duration)+2: 
                                             item.seek_bar_data.stop*100/item.seek_bar_data.duration
                                       ) > 98"></div>
                                 <a href="javascript:;" class="_ep_p">
                                    <img src="assets/img/asset_play_icon.png" class="_ep_icon_play">
                                 </a>
                                
                              </div>
                              <div class="episode-detail" *ngIf="item.no">
                                 <div class="ep-no">
                                    <h4><b>{{item.no}}. </b>{{item.name}}
                                    </h4>
                                 </div>
                                 <div class="ep-detail">

                                    <p class="synopsisHight" (click)="expendEpisodeSynopsis(i)"
                                       [ngClass]="{'episodeSynopsisHight': episodeIndex == i}">
                                       {{item.synopsis}}</p>
                                    <div class="time" *ngIf="item.hours >0 && item.min >0&& item.sec>0">
                                       <p *ngIf="item.hours > 0"> <span>{{commonService.pad(item.hours)}}h</span></p>
                                       <p *ngIf="item.min > 0"> <span>{{commonService.pad(item.min)}}m</span></p>
                                    </div>

                                    <div class="time" *ngIf="!(item.hours >0 && item.min >0&& item.sec>0)">

                                       <p *ngIf="item.hours > 0"><span>{{commonService.pad(item.hours)}}h</span>
                                       <p *ngIf="item.min > 0"><span>{{commonService.pad(item.min)}}m</span>
                                       <p>
                                       <p *ngIf="item.sec > 0"> <span>{{commonService.pad(item.sec)}}{{item.sec >
                                             1?'s':'s'}}</span></p>
                                    </div>
                                 </div>
                              </div>
                           </div>

                        </div> -->

                        <div class="tab-pane fade show" id="episode" role="tabpanel" aria-labelledby="episode-tab"
                           [ngClass]="{'active show': (tempQueryStr.type =='tvshow' && seasonData && seasonData.result && seasonData.result.season && seasonData.result.season.length>0)}"
                           *ngIf="tempQueryStr.type == 'tvshow' && seasonData && seasonData.result && seasonData.result.season">

                           <div class="dropdown season-drpdwn" *ngIf="this.seasonData.result.season.length  > 1">

                              <button class="btn btn-secondary dropdown-toggle season-button" type="button"
                                 id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                 aria-expanded="false">
                                 {{currentSeaon?currentSeaon:'Season 1'}} <i class="fa fa-angle-down"
                                    aria-hidden="true"></i>
                              </button>

                              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                 <a class="dropdown-item" *ngFor="let season of seasonData.result.season; let i=index"
                                    (click)="changeSeason(season.season_id, i+1, season.season_number)">Season {{i+1}}
                                 </a>
                              </div>
                           </div>
                           <div class="search-results" infiniteScroll [infiniteScrollDistance]="5"
                              [infiniteScrollThrottle]="25" (scrolled)="onScroll()">
                              <div *ngIf="allEpisode">
                                 <div class="season-detail wow animate__animated  animate__fadeInUp"
                                    *ngFor="let item of allEpisode.result[0].assets; let i=index">
                                    <div class="episode-img" (click)="playvideoRecomnd(item, play_episode)">

                                       <image-manipulation [img]="isCloudFrontType == false ? item.image : item.image_cloudfront_url" [params]="{'width':291,'height':160}" [notFound]="notFoundImg">
                                       </image-manipulation>


                                       <div *ngIf="item.hide_tag!=1">
                                          <a class="_premium" *ngIf="strToLower(item.content_availability) == 'paid'">
                                             <img class="crown" src="assets/img/crown.png">
                                          </a>

                                          <a class="_free_tag" *ngIf="strToLower(item.content_availability) == 'free'">
                                             <img class="crown" src="assets/img/free_tag_76x35.png">
                                          </a>

                                          <a class="_free_tag"
                                             *ngIf="strToLower(item.content_availability) == 'no tag'">
                                          </a>
                                       </div>

                                       <div class="progress progress_bottom_img" *ngIf="item.seek_bar_data">
                                          <div *ngIf="item.hours!='' && item.min!='' && item.sec!=''" class="progress-bar" role="progressbar" aria-valuenow="70"
                                          aria-valuemin="0" aria-valuemax="100"
                                          [ngStyle]="{'width': (item.seek_bar_data.stop*100/item.seek_bar_data.duration) >= 97 ? (item.seek_bar_data.stop*100/item.seek_bar_data.duration+2): (item.seek_bar_data.stop*100/item.seek_bar_data.duration)  +'%'}">
                                       </div>
                                       <div *ngIf="item.hours=='' && item.min=='' && item.sec==''" class="progress-bar" role="progressbar" aria-valuenow="70"
                                          aria-valuemin="0" aria-valuemax="100"
                                          [ngStyle]="{'width': '0%'}">
                                       </div>
                                       </div>

                                       <div class="shade" *ngIf="( 
                                             (item.seek_bar_data.stop*100/item.seek_bar_data.duration) >= 97 ? 
                                             (item.seek_bar_data.stop*100/item.seek_bar_data.duration)+2: 
                                             item.seek_bar_data.stop*100/item.seek_bar_data.duration
                                       ) > 98"></div>
                                       <a href="javascript:;" class="_ep_p">
                                          <img src="assets/img/asset_play_icon.png" class="_ep_icon_play">
                                       </a>

                                    </div>
                                    <div class="episode-detail" *ngIf="item.no">
                                       <div class="ep-no">
                                          <h4><b>{{item.no}}. </b>{{item.name}}
                                          </h4>
                                       </div>
                                       <div class="ep-detail">

                                          <p class="synopsisHight" (click)="expendEpisodeSynopsis(i)"
                                             [ngClass]="{'episodeSynopsisHight': episodeIndex == i}">
                                             {{item.synopsis}}</p>
                                          <div class="time" *ngIf="item.hours >0 && item.min >0&& item.sec>0">
                                             <p *ngIf="item.hours > 0"> <span>{{commonService.pad(item.hours)}}h</span>
                                             </p>
                                             <p *ngIf="item.min > 0"> <span>{{commonService.pad(item.min)}}m</span></p>
                                          </div>

                                          <div class="time" *ngIf="!(item.hours >0 && item.min >0&& item.sec>0)">

                                             <p *ngIf="item.hours > 0"><span>{{commonService.pad(item.hours)}}h</span>
                                             <p *ngIf="item.min > 0"><span>{{commonService.pad(item.min)}}m</span>
                                             <p>
                                             <p *ngIf="item.sec > 0"> <span>{{commonService.pad(item.sec)}}{{item.sec >
                                                   1?'s':'s'}}</span></p>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                           <ng-http-loader [backgroundColor]="'#ff0000'"></ng-http-loader>
                        </div>

                        <div class="tab-pane fade" *ngIf="recommendedData.result && recommendedData.result.length > 0"
                           [ngClass]="{'active show': (tempQueryStr.type !='tvshow' && episodeDeatil.new_trailer && episodeDeatil.new_trailer.length <= 1 && recommendedData.result && recommendedData.result.length > 0
                                                   || tempQueryStr.type =='tvshow' && episodeDeatil.new_trailer && episodeDeatil.new_trailer.length <= 1 && seasonData && seasonData.result && seasonData.result.season && seasonData.result.season.length<1 && recommendedData.result && recommendedData.result.length > 0)}"
                           id="recommendforyou" role="tabpanel" aria-labelledby="profile-tab">

                           <section class="other_assests">
                              <div>
                                 <div class="row m5">
                                    <div class="col-sm-12 p-0">
                                       <div class="view_more"
                                          *ngIf="recommendedData.result && recommendedData.result.length > 0">
                                          <div class="_v_all_parent">
                                             <div class="asset_4 p15"
                                                *ngFor="let item of recommendedData.result; let i=index">
                                                <div class="_view_img_list_p">
                                                   <div class="_watching_img1"
                                                      [ngClass]="{'live_tv': item.type == 'livetv'}">
                                                      <!-- <img src="{{item.thumbnail?item.thumbnail:'assets/img/image-not-found.png'}}" class="grid_item" alt="grid_img"> -->
                                                      <!-- <img src="{{item.thumbnail?item.thumbnail:'assets/img/image-not-found.png'}}" class="grid_item" (click)="redirectUrl(item, content)" alt="grid_img">
                                                      <span class="live" *ngIf="item.type == 'livetv'">Live</span>
                                                      <div *ngIf="viewAll.result[0].category_name == 'Continue Watching'" class="progress">
                                                      <div  class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100" [ngStyle]="{'width': item.stop*100/item.duration+'%'}" >                                  
                                                      </div>
                                                      </div> -->
                                                      <div class="p_g_i" id="cont_thombImage{{i}}"
                                                         (click)="detailPageRedirect(item)">
                                                         <!-- <img
                                                      src="{{item.thumbnail?item.thumbnail:'assets/img/image-not-found.png'}}"
                                                      class="grid_item" alt="grid_img"> -->


                                                         <image-manipulation
                                                            *ngIf="item.type != 'livetv'"
                                                            [img]="isCloudFrontType == false ? item.thumbnail : item.thumbnail_cloudfront_url"
                                                            [params]="{'width':330,'height':180}" [notFound]="notFoundImg">
                                                         </image-manipulation>
                                                         <image-manipulation
                                                            *ngIf="item.type == 'livetv'"
                                                            [img]="isCloudFrontType == false ? item.thumbnail : item.thumbnail_cloudfront_url"
                                                            [params]="{'width':140,'height':140,'crop':'fill','gravity':'center'}" [notFound]="notFoundImg">
                                                         </image-manipulation>

                                                         <!-- <a class="_premium" *ngIf="item.content_availability != 'FREE'">
                                                      <img class="crown" src="assets/img/crown.png">
                                                   </a> -->

                                                         <a class="_premium"
                                                            *ngIf="strToLower(item.content_availability) == 'paid'">
                                                            <img class="crown" src="assets/img/crown.png">
                                                         </a>

                                                         <a class="_free_tag"
                                                            *ngIf="strToLower(item.content_availability) == 'free'">
                                                            <img class="crown" src="assets/img/free_tag_76x35.png">
                                                         </a>

                                                         <a class="_free_tag"
                                                            *ngIf="strToLower(item.content_availability) == 'no tag'">
                                                            <!-- <img class="crown" src="assets/img/free_tag_76x35.png"> -->
                                                         </a>



                                                         <a class="_cross_icon"
                                                            *ngIf="item.category_name == 'Continue Watching'">
                                                            <img class="crown" (click)="setDeleteItemForDelete(item)"
                                                               data-toggle="modal" data-target="#removeWatchListSlider"
                                                               src="assets/img/asset_cross_icon.png">
                                                         </a>
                                                         <span class="live" *ngIf="item.type == 'livetv'">Live</span>
                                                         <div *ngIf="item.category_name == 'Continue Watching'"
                                                            class="progress">
                                                            <div class="progress-bar" role="progressbar"
                                                               aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
                                                               [ngStyle]="{'width': item.stop*100/item.duration+'%'}">
                                                            </div>
                                                         </div>

                                                         <!-- <div *ngIf="item.type == 'livetv'" class="progress">
                                                            <div  class="progress-bar" role="progressbar" aria-valuenow="{{item.totalPlayed}}" aria-valuemin="0" aria-valuemax="{{item.duration}}" 
                                                            [ngStyle]="{'width': item.totalPlayed +'%'}" >                                  
                                                            </div>
                                                      </div> -->

                                                      </div>
                                                      <div class="_visible_hover1" id="cont_thombMore{{i}}">
                                                         <div class="_v_c_l">
                                                            <a href="javascript:;" (click)="detailPageRedirect(item)">
                                                               <div class="_c_img">
                                                                  <img src="assets/img/hover_Play.png">
                                                               </div>
                                                               <div class="_c_progress">
                                                                  <span>watch now</span>
                                                               </div>
                                                            </a>


                                                            <div class="_right_c_t">
                                                               <!-- <span class="rating_s">
                                                            U/A 16+ 
                                                        </span> -->
                                                               <span class="rating_s"
                                                                  *ngIf="(item?.viewer_rating) && item?.viewer_rating?.rating_name">
                                                                  {{item?.viewer_rating?.rating_name}}
                                                               </span>


                                                               <!-- <a class="add_play_llist"
                                                               (click)="AddToWatchList($event, item, 'recommend')">
                                                               <img
                                                                  [src]="item.is_watchlist_added?'assets/img/Added_to_Watchlist.png':'assets/img/Add-to_Watchlist.png'">
                                                               <span class="_hover_watchlist">
                                                                  {{item.is_watchlist_added?'Remove from Watchlist':'Add
                                                                  to
                                                                  Watchlist'}}
                                                               </span>
                                                            </a> -->
                                                            </div>

                                                         </div>
                                                         <div class="_inner_text_l" (click)="detailPageRedirect(item)">
                                                            <h4>{{item.name | slice:0:40}}
                                                               <span
                                                                  *ngIf="item.name && item.name.length > 40">...</span>
                                                            </h4>
                                                            <p class="type_film">

                                                               <!-- {{item.genre_text?item.genre_text:''}} -->

                                                               <!-- {{(item.hours||item.min||item.sec) && item.genre_text?'|': ''}} 
                                                            
                                                            {{item.hours>0?item.hours+' hrs ':''}}
                                                            {{item.min>0?item.min+' min ':''}}
                                                            {{item.sec>0?item.sec+' sec ':''}} -->
                                                               <!-- {{item.languages?"|":""}}
                                                            {{item.languages?item.languages:''}} -->

                                                               <!-- {{item.languages?item.languages:''}}

                                                               {{item.genre_text&&item.genre_text?"|":""}}
                                                               {{item.genre_text?item.genre_text:''}} -->

                                                               <!-- {{item.viewer_rating&&item.viewer_rating?"|":""}}
                                                               {{item?.viewer_rating?.rating_name}} -->

                                                            </p>
                                                            <p>{{item.synopsis | slice:0:100}}
                                                               <span
                                                                  *ngIf="item.synopsis && item.synopsis.length > 100">...</span>
                                                            </p>
                                                         </div>
                                                      </div>

                                                   </div>
                                                </div>
                                             </div>
                                          </div>
                                       </div>

                                       <div class="color_white" *ngIf="loading">
                                          <!-- <p>Loading! Please Wait...</p>  -->
                                       </div>
                                       <div
                                          *ngIf="recommendedData.result.length == 0 || !recommendedData || !recommendedData.result">
                                          <h4 class="accinner-head"
                                             style="color:#fff; margin-top: 10%; margin-left:30%;">
                                             No Data found in this category
                                          </h4>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </section>

                        </div>
                        <div class="tab-pane fade" [ngClass]="{'active show': ((recommendedData.result.length<=0 || recommendedData.result==false) && episodeDeatil.new_trailer.length<=1 && !seasonData && seasonData==undefined
                        || (recommendedData.result.length<=0 || recommendedData.result==false) && episodeDeatil.new_trailer.length<=1 && tempQueryStr.type =='tvshow' && seasonData && seasonData.result)}" id="moreinfo" role="tabpanel"
                           aria-labelledby="contact-tab">
                           <ul class="account-body _more_info_detail" style="color: #fff;">
                              <!-- data-toggle="modal" data-target="#add_name" -->

                              <li *ngIf="episodeDeatil?.languages">
                                 <h4>Language</h4>
                                 <p>{{episodeDeatil?.languages}}</p>
                              </li>

                              <li *ngIf="episodeDeatil?.genre_text">
                                 <h4>Genre</h4>
                                 <p>{{episodeDeatil?.genre_text}}</p>
                              </li>
                              <li *ngIf="(episodeDeatil?.viewer_rating) && episodeDeatil?.viewer_rating?.rating_name">
                                 <h4>Maturity Rating</h4>
                                 <p>{{episodeDeatil?.viewer_rating?.rating_name}}</p>
                              </li>
                              <li *ngIf="episodeDeatil?.advisory">
                                 <h4>Content Advisory</h4>
                                 <p>{{episodeDeatil?.advisory}}</p>
                              </li>
                              <li *ngIf="episodeDeatil?.actor_names">
                                 <h4>Cast</h4>
                                 <p>{{episodeDeatil?.actor_names}}</p>
                              </li>

                              <li *ngIf="episodeDeatil?.director_name">
                                 <h4>Director</h4>
                                 <p>{{episodeDeatil?.director_name}}</p>
                              </li>
                              <li *ngIf="episodeDeatil?.producer_name">
                                 <h4>Producer</h4>
                                 <p>{{episodeDeatil?.producer_name}}</p>
                              </li>
                              <li *ngIf="episodeDeatil?.writer_name">
                                 <h4>Writer</h4>
                                 <p>{{episodeDeatil?.writer_name}}</p>
                              </li>
                              <li *ngIf="episodeDeatil?.singer_names">
                                 <h4>Singer</h4>
                                 <p>{{episodeDeatil?.singer_names}}</p>
                              </li>
                              <li *ngIf="episodeDeatil?.production_house_name">
                                 <h4>Production House</h4>
                                 <p>{{episodeDeatil?.production_house_name}}</p>
                              </li>
                              <li *ngIf="episodeDeatil?.boradcaster_name">
                                 <h4>Boradcaster</h4>
                                 <p>{{episodeDeatil?.boradcaster_name}}</p>
                              </li>
                              <li *ngIf="episodeDeatil?.music_director_name">
                                 <h4>Music Director</h4>
                                 <p>{{episodeDeatil?.music_director_name}}</p>
                              </li>
                              <li *ngIf="episodeDeatil?.release_date">
                                 <h4>Release Date</h4>
                                 <p>{{episodeDeatil?.release_date}}</p>
                              </li>


                              <!-- <li *ngIf="episodeDeatil?.director_name && episodeDeatil?.producer_name && episodeDeatil?.writer_name">
                                 <h4>
                                    Crew
                                 </h4>
                                 <p>
                                    <span *ngIf="episodeDeatil?.director_name">Director:</span>{{episodeDeatil?.director_name}} <span *ngIf="episodeDeatil?.producer_name">Producers:</span> {{episodeDeatil.producer_name}}<span *ngIf="episodeDeatil?.writer_name"> Writer:</span> {{episodeDeatil.writer_name}}</p>
                              </li> -->
                           </ul>
                        </div>
                     </div>

                  </div>

                  <!-- slimilar for livetv -->
                  <div class="col-sm-12" *ngIf="episodeDeatil.type == 'livetv'">

                     <app-epgslider (getProgramDetail)="getAssetsData()" [episode_Deatil]="episodeDeatil">
                     </app-epgslider>
                     <div class="maincontentarea">
                        <div class="_view_all_d" *ngIf="recommendedData.result && recommendedData.result.length > 0">
                           <section class="other_assests">
                              <h4 class="accinner-head" style="color:#fff">Similar Channels</h4>

                              <div class="view_more">
                                 <div class="_v_all_parent live_tv">
                                    <div class="_view_img_list_p live_tv_mr10"
                                       *ngFor="let item of recommendedData.result; let i=index">
                                       <div class="_watching_img1 live_tv" (click)="detailPageRedirect(item)">
                                          <div class="p_g_i" id="cont_thombImage{{i}}">
                                             <!-- <img  src="{{item.channel_image?item.channel_image:'assets/img/image-not-found.png'}}" class="grid_item" alt="grid_img"> -->
                                             <!-- <img *ngIf="!item.channel_image" src="assets/img/image-not-found.png" class="grid_item" alt="grid_img"> -->
                                             <!-- <img *ngIf="isCloudFrontType == false && item.channel_image || isCloudFrontType == true && item.channel_image_cloudfront_url" src="assets/img/image-not-found.png"
                                                class="grid_item" alt="grid_img"> -->

                                             <image-manipulation [img]="isCloudFrontType == false ?  item.channel_image : item.channel_image_cloudfront_url"
                                                [params]="{'width':140,'height':140,'crop':'fill','gravity':'center'}" [notFound]="notFoundImg">
                                             </image-manipulation>


                                             <!-- <a class="_premium" *ngIf="strToLower(item.content_availability) != 'free'">
                                             <img class="crown" src="assets/img/crown.png">
                                          </a> -->
                                             <a class="_premium"
                                                *ngIf="strToLower(item.content_availability) == 'paid'">
                                                <img class="crown" src="assets/img/crown.png">
                                             </a>

                                             <a class="_free_tag"
                                                *ngIf="strToLower(item.content_availability) == 'free'">
                                                <img class="crown" src="assets/img/free_tag_76x35.png">
                                             </a>

                                             <a class="_free_tag"
                                                *ngIf="strToLower(item.content_availability) == 'no tag'">
                                                <!-- <img class="crown" src="assets/img/free_tag_76x35.png"> -->
                                             </a>

                                             <!-- <span class="live" *ngIf="item.type == 'livetv'">Live</span> -->

                                          </div>
                                          <div class="_visible_hover1" id="cont_thombMore{{i}}">
                                             <div class="_v_c_l">
                                                <a href="javascript:;">
                                                   <img src="assets/img/hover_Play.png">
                                                   <span>watch now</span>
                                                </a>


                                                <div class="_right_c_t">
                                                   <!-- <span class="rating_s">
                                          U/A 16+
                                      </span> -->
                                                   <span class="rating_s"
                                                      *ngIf="(item?.viewer_rating) && item?.viewer_rating?.rating_name">
                                                      {{item?.viewer_rating?.rating_name}}
                                                   </span>

                                                   <a class="add_play_llist"
                                                      (click)="AddToWatchList($event, item, 'liveTv')">
                                                      <img
                                                         [src]="item.is_watchlist_added?'assets/img/Added_to_Watchlist.png':'assets/img/Add-to_Watchlist.png'">
                                                      <!-- <img src="assets/img/hover_add_to_watch_list_icon.png"> -->
                                                      <span class="_hover_watchlist">
                                                         {{item.is_watchlist_added?'Remove from Watchlist':'Add to
                                                         Watchlist'}}
                                                      </span>
                                                   </a>
                                                </div>

                                             </div>
                                             <div class="_inner_text_l">
                                                <h4 (click)="redirectUrl(item, content)">{{item.channel_name}}</h4>
                                                <p class="type_film">
                                                   <!-- {{item.genre_text?item.genre_text:''}} -->

                                                   <!-- 
                                          {{(item.hours||item.min||item.sec) && item.genre_text?'|': ''}} 
                                          {{item.hours>0?item.hours+' hrs ':''}}
                                          {{item.min>0?item.min+' min ':''}}
                                          {{item.sec>0?item.sec+' sec ':''}} 
                                       -->
                                                   <!-- {{item.languages?"|":""}}
                                                   {{item.languages?item.languages:''}} -->

                                                </p>


                                                <p>{{item.synopsis | slice:0:45}}
                                                   <span *ngIf="item.synopsis && item.synopsis.length > 45">...</span>
                                                </p>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>


                                 <div *ngIf="recommendedData.result.length == 0">
                                    <h4 class="no-result">Sorry, Your Category is Empty <span> <b></b></span></h4>

                                 </div>
                              </div>
                           </section>
                        </div>
                     </div>
                  </div>

               </div>
            </div>
         </section>

         <!-- <ng-template #livetvContent let-modal>
      </ng-template> -->

         <ng-template #content let-modal>
            <app-videojs-player [streamInfo]="episodeDeatil" (onModalClose)="onModalClosed($event)">
            </app-videojs-player>
            <!-- <app-jw-video-player [streamInfo]="episodeDeatil"></app-jw-video-player> -->
         </ng-template>

         <ng-template #contentLive let-modal>
            <app-live [streamInfo]="episodeDeatil" (onModalClose)="onModalClosed($event)"></app-live>
         </ng-template>

         <ng-template #playFromStart let-modal>
            <app-videojs-player [streamInfo]="playvideoFromStart" (onModalClose)="onModalClosed($event)">
            </app-videojs-player>
            <!-- <app-jw-video-player [streamInfo]="episodeDeatil"></app-jw-video-player> -->
         </ng-template>


         <ng-template #play_episode let-modal>
            <app-videojs-player [streamInfo]="playEpisodeData" (onModalClose)="onModalClosed($event)">
            </app-videojs-player>
            <!-- <app-jw-video-player [streamInfo]="episodeDeatil"></app-jw-video-player> -->
         </ng-template>
         <ng-template #play_trailer let-modal>
            <app-videojs-player [streamInfo]="playTrailer" ></app-videojs-player>
            <!-- <app-jw-video-player [streamInfo]="episodeDeatil"></app-jw-video-player> -->
         </ng-template>
         <ng-template #play_preview let-modal>
            <app-videojs-player [streamInfo]="playPreview"></app-videojs-player>
            <!-- <app-jw-video-player [streamInfo]="episodeDeatil"></app-jw-video-player> -->
         </ng-template>
      </div>

      <div *ngIf="showError">
         <div class="container">
            <div class="row">
               <div class="col-sm-12">
                  <div class="_no_data_f">
                     <h1>No Data Found</h1>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
   <!--End Episode list -->
   <!-- </div> -->

   <a data-toggle="modal" data-target="#addToWatchListfromdetail" #addToWatchListSuccessFromDetail></a>


   <div class="modal auth" id="addToWatchListfromdetail" *ngIf="userInfo">
      <div class="modal-dialog modal-dialog-centered modal-dialog-zoom">
         <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header" style="visibility: hidden;">
               <button type="button" id="removeToWatchListSuccessModal" class="close" data-dismiss="modal"
                  #removeToWatchListSuccessModal>&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
               <div class="success-add">
                  <img src="../../../assets/img/success.png">
                  <p *ngIf="error_code == '200'">Successfully added to Watchlist.</p>
                  <p *ngIf="error_code == '209'">Successfully removed from Watchlist.</p>
               </div>
            </div>
         </div>
      </div>
   </div>

   <!--Cancel subscription -->
   <div class="modal auth" id="add_watch_list">
      <div class="modal-dialog modal-dialog-centered modal-dialog-zoom" role="document">
         <div class="modal-content">
            <div class="modal-header">
               <h5 class="modal-title">Are you sure ?</h5>
               <button type="button" class="close" data-dismiss="modal" aria-label="Close" #closeAddtoWatchListModal>
                  <span aria-hidden="true">&times;</span>
               </button>
            </div>
            <!-- <div class="modal-body" *ngIf="remove_subscription_error != ''">
                <p class="error">{{remove_subscription_error}}</p>
              </div> -->
            <div class="modal-footer">
               <!-- <button type="button" class="btn btn-primary" (click)="addWatchList()">Yes</button> -->
               <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">No</button> -->
               <a href="" data-toggle="modal" data-target="#pack_removed_success" #showPackSuccess></a>
            </div>
         </div>
      </div>
   </div>
   <!-- Cancel subscription -->


   <!--Cancel subscription -->
   <div class="modal auth" id="sharebuttons">
      <div class="modal-dialog" role="document">
         <div class="modal-content">
            <div class="modal-header">
               <h4 class="modal-title">Share</h4>
               <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
               <!-- <share-button button="facebook" text="Share" ></share-button> -->

               <!-- <share-popup-button>Share</share-popup-button> -->
               <div class="_social_icon">
                  <button>
                     <i class="fa fa-envelope-o" (click)="openMailBody()" aria-hidden="true"></i>
                     <h5>Email</h5>
                  </button>
                  <button>
                     <i class="fa fa-facebook-square" (click)="shareFB()" data-js="facebook-share"
                        aria-hidden="true"></i>
                     <h5>Facebook</h5>
                     <!-- <i class="fa fa-facebook-square" (click)="shareFB()" data-js="facebook-share" aria-hidden="true"></i> -->
                  </button>
                  <button>
                     <i class="fa fa-twitter-square" (click)="shareTB()" aria-hidden="true"></i>
                     <h5>Twitter</h5>
                  </button>
               </div>
               <div class="social_btn">

                  <button *ngIf="!copyLink" type="button" ngxClipboard
                     [cbContent]="episodeDeatil && episodeDeatil['share_url']" class="btn btn-default register"
                     (cbOnSuccess)="contentCopied($event)">Copy Link</button>
               </div>
               <div class="social_btn">

                  <button *ngIf="copyLink" type="button" ngxClipboard
                     [cbContent]="episodeDeatil && episodeDeatil['share_url']"
                     class="btn btn-default register">Copied!</button>
               </div>
            </div>
         </div>
      </div>
   </div>
   <!-- Cancel subscription -->



   <a data-toggle="modal" data-target="#device_not_allowed" #deviceNotAllowed></a>
   <div class="modal auth" id="device_not_allowed">
      <div class="modal-dialog modal-dialog-centered modal-dialog-zoom">
         <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header" style="visibility: hidden;">
               <button type="button" id="closeAddToWatchListInBanner" class="close"
                  data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
               <div class="success-add">
                  <img src="../../../assets/img/error_icon.png">
                  <p>{{this.deviceMsg}}</p>
                  <!-- <p id="bannerAddToWatchList">rewrt</p> -->
               </div>
            </div>
         </div>
      </div>
   </div>
   <button type="button" [hidden]="true" class="dropdown-item" (click)="openLoginModal(content)" #openLoginModel>Tell Us Modal</button>
   <ng-template #content let-modal>
      <app-login></app-login>
    </ng-template>